/**
 * Account Settings API
 * 계정 설정 관련 API
 */

import { apiClient } from '@shared/api/client';

export interface AccountInfo {
  userId: string;
  email: string;
  fullName: string | null;
  firstName: string | null;
  lastName: string | null;
  middleName: string | null;
  language: string;
  dateFormat: string;
  userLoleCode: string | null;
  lastLoginDate: string | null;
  userImage: string | null;
}

export const accountSettingsApi = {
  /**
   * 계정 정보 조회 (DB에서 최신 데이터)
   */
  getAccount: () => {
    return apiClient.get<{ user: AccountInfo }>('/account-settings/account');
  },

  /**
   * 프로필 이미지 업로드
   */
  uploadProfileImage: (file: File) => {
    const formData = new FormData();
    formData.append('profileImage', file);
    return apiClient.post<{ url: string; imageUrl: string }>('/account-settings/profile-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /**
   * 프로필 이미지 삭제
   */
  deleteProfileImage: () => {
    return apiClient.delete<{ success: boolean }>('/account-settings/profile-image');
  },

  /**
   * 계정 정보 업데이트 (L_LOGIN_USERS 테이블 필드 기반)
   */
  updateAccount: (data: {
    fullName?: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
    defaultLangCd?: string;
    dateFormat?: string;
    userRole?: string;
  }) => {
    return apiClient.patch<{ success: boolean }>('/account-settings/account', data);
  },

  /**
   * 비밀번호 변경
   */
  changePassword: (data: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }) => {
    return apiClient.post<{ success: boolean }>('/account-settings/change-password', data);
  },

  /**
   * MFA 상태 조회
   */
  getMFAStatus: () => {
    return apiClient.get<{ isEnabled: boolean; hasSecretKey: boolean; setupDate: string | null }>('/account-settings/mfa/status');
  },

  /**
   * MFA QR 코드 생성
   */
  generateMFAQR: () => {
    return apiClient.post<{ qrCodeUrl: string; secretKey: string; manualEntryKey: string }>('/account-settings/mfa/generate-qr');
  },

  /**
   * MFA 검증 및 활성화
   */
  verifyAndEnableMFA: (data: {
    secretKey: string;
    token: string;
  }) => {
    return apiClient.post<{ verified: boolean; mfaEnabled: boolean; message: string }>('/account-settings/mfa/verify-and-enable', data);
  },

  /**
   * MFA 비활성화
   */
  disableMFA: () => {
    return apiClient.post<{ mfaEnabled: boolean; message: string }>('/account-settings/mfa/disable');
  },
};

